/* ============================================================
   Product page — JS original (Stratégie 2)
   - Sélection de variante (prix, dispo, média, URL)
   - Ajout au panier AJAX -> ouvre le drawer
   ============================================================ */
(function () {
  'use strict';

  /* Deux sections peuvent demander ce controleur sur la meme page — la
     fiche produit et le produit mis en avant. Le navigateur ne telecharge
     le fichier qu'une fois, mais l'execute a chaque balise : sans cette
     garde, les ecouteurs de `shopify:section:load` se dupliqueraient. */
  if (window.lfPdpCharge) return;
  window.lfPdpCharge = true;

  function init(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var sectionId = root.dataset.sectionId;
    var productUrl = root.dataset.url;
    var dataEl = root.querySelector('[data-lf-variant-data]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = root.querySelector('[data-lf-variant-id]');

    /* ---- Produits complementaires ----
       Le bloc porte l'adresse de l'API de recommandations, rendue pour
       cette section : on n'en garde que le bloc lui-meme. Sans produit
       complementaire, il reste vide et masque. */
    root.querySelectorAll('[data-lf-compl][data-url]').forEach(function (bloc) {
      if (bloc.dataset.lfComplCharge) return;
      bloc.dataset.lfComplCharge = '1';
      fetch(bloc.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neuf = doc.querySelector('[data-lf-compl="' + bloc.dataset.lfCompl + '"]');
          if (neuf && neuf.querySelector('.lf-compl__item')) bloc.innerHTML = neuf.innerHTML;
        })
        .catch(function () {});
    });

    /* ---- Sélection de variante ---- */
    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-lf-opt]:checked').forEach(function (i) { opts.push(i.value); });
      return opts;
    }

    /* ---- Filtrage des photos par couleur sélectionnée ---- */
    var colorIndex = parseInt(root.getAttribute('data-lf-color-index'), 10) || 0;
    function filterMedia() {
      if (!colorIndex) return;
      var checked = root.querySelector('input[name="option' + colorIndex + '"]:checked');
      var color = checked ? checked.value : '';
      var vignettes = root.querySelectorAll('.lf-product__slide[data-variant-color]');

      /* Le gabarit etiquette CHAQUE vignette d'une couleur — celle de la
         variante qui la met en avant, ou la precedente reportee. Aucune n'est
         donc neutre. Un marchand qui ajoute une couleur sans lui assigner de
         photo voyait alors la galerie entiere disparaitre : toutes les
         vignettes portaient une autre couleur, toutes etaient masquees, et la
         fiche produit se retrouvait sans image du tout. On compte d'abord ; si
         cette couleur n'a rien a montrer, on montre tout plutot que rien. */
      var correspondent = 0;
      vignettes.forEach(function (s) {
        if (s.getAttribute('data-variant-color') === color) correspondent++;
      });

      vignettes.forEach(function (s) {
        var mc = s.getAttribute('data-variant-color');
        var garder = !correspondent || !mc || mc === color;
        s.style.display = garder ? '' : 'none';
      });
      /* Les vignettes suivent : sans cela elles menerait a des visuels masques. */
      root.querySelectorAll('.lf-product__thumb[data-variant-color]').forEach(function (t) {
        var mc = t.getAttribute('data-variant-color');
        t.style.display = (!mc || mc === color) ? '' : 'none';
      });
    }

    /* ---- Plans d'abonnement ----
       Le bloc est re-rendu par le serveur a chaque variante : c'est lui qui
       sait quels rythmes existent pour celle-ci, et a quel prix. Le
       JavaScript ne fait que deux choses — tenir le champ cache a jour, et
       reconduire le choix du client quand la nouvelle variante le permet
       encore. La delegation est posee sur la racine, pas sur le bloc, sinon
       elle disparaitrait avec lui au premier remplacement. */
    function planChoisi() {
      var coche = root.querySelector('[data-lf-plan-option]:checked');
      return coche ? coche.value : '';
    }

    function poserPlan(valeur) {
      var champ = root.querySelector('[data-lf-selling-plan-input]');
      if (champ) champ.value = valeur || '';
    }

    function reconduirePlan(avant) {
      var options = root.querySelectorAll('[data-lf-plan-option]');
      if (!options.length) { poserPlan(''); return; }
      var garde = null;
      options.forEach(function (o) { if (o.value === avant) garde = o; });
      /* Le rythme choisi n'existe pas pour cette variante : on retombe sur
         ce que le serveur a coche, plutot que d'envoyer au panier un plan
         que la variante ne connait pas. */
      var cible = garde || root.querySelector('[data-lf-plan-option]:checked') || options[0];
      cible.checked = true;
      poserPlan(cible.value);
    }

    /* L'adresse d'un rendu de section : la variante, et le rythme quand il
       y en a un. Sans `selling_plan`, le serveur rend le prix plein — ce
       qui affichait 99,90 sur un produit facture 84,92. */
    function urlSection(idVariante, plan) {
      var u = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') +
              'variant=' + idVariante + '&section_id=' + sectionId;
      if (plan) u += '&selling_plan=' + plan;
      return u;
    }

    var requetePrix = null;

    /* Changer de rythme ne change pas de variante : rien ne redemandait le
       prix au serveur. On ne remplace que le bloc de prix — refaire le bloc
       des rythmes replacerait le bouton radio sous le doigt du client. */
    function rafraichirPrix() {
      var champId = root.querySelector('[name="id"]');
      if (!champId || !champId.value) return;
      if (requetePrix) requetePrix.abort();
      requetePrix = new AbortController();
      var attendu = planChoisi();
      fetch(urlSection(champId.value, attendu), { signal: requetePrix.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (planChoisi() !== attendu) return;
          swap(new DOMParser().parseFromString(html, 'text/html'), '[data-lf-price]');
        })
        .catch(function () {});
    }

    root.addEventListener('change', function (e) {
      var opt = e.target.closest('[data-lf-plan-option]');
      if (opt) { poserPlan(opt.value); rafraichirPrix(); }
    });

    /* Un produit qui exige un abonnement arrive avec son premier rythme
       coche, mais le champ cache que Shopify lit n'etait rempli qu'au
       changement de variante : l'ajout partait sans rythme et le serveur le
       refusait. On l'aligne des le chargement sur le choix affiche. */
    var planAffiche = root.querySelector('[data-lf-plan-option]:checked');
    if (planAffiche) poserPlan(planAffiche.value);

    var requeteVariante = null;

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    /* Une combinaison peut n'exister chez aucune variante. Le code se
       contentait de sortir : le champ cache gardait l'identifiant de la
       variante precedente, le bouton restait actif, et le client ajoutait
       au panier autre chose que ce qu'il avait choisi. On declare
       explicitement l'etat indisponible. */
    /* Libelle et etat du bouton d'ajout, poses tout de suite depuis les
       donnees de variante. On n'attend pas le rendu du serveur : sur le
       produit mis en avant, la requete vise un identifiant de section qui
       n'existe pas sur la page produit, et le bouton restait fige. */
    function poserBouton(etat) {
      var mots = window.lfStrings || {};
      var libelle = etat === 'disponible' ? mots.addToCart : etat === 'epuise' ? mots.soldOut : mots.unavailableLabel;

      /* Le paiement accelere doit disparaitre avec l'ajout au panier. Il
         n'etait masque que pour une combinaison inexistante : sur une
         declinaison bien reelle mais epuisee, le bouton d'ajout passait a
         « Sold out » et se desactivait pendant que Shop Pay restait cliquable
         a cote. Le client partait payer un article introuvable. Shopify
         demande que les deux se desactivent ensemble — c'est ici qu'il faut
         le faire, et non au moment ou l'on resout la declinaison, puisque
         c'est ici que l'etat est connu. */
      var accel = root.querySelector('.shopify-payment-button');
      if (accel) accel.hidden = etat !== 'disponible';

      var atc = root.querySelector('[data-lf-atc]');
      if (!atc) return;
      atc.querySelectorAll('button[name="add"], [type="submit"]').forEach(function (b) {
        var inactif = etat !== 'disponible';
        b.disabled = inactif;
        if (inactif) b.setAttribute('aria-disabled', 'true');
        else b.removeAttribute('aria-disabled');
        if (!libelle) return;
        var texte = b.querySelector('[data-lf-atc-text]');
        if (texte) texte.textContent = libelle;
        else b.textContent = libelle;
      });
    }

    function poserIndisponible() {
      if (idInput) idInput.value = '';

      /* Le retrait en magasin doit s'effacer lui aussi : sans cet avis, il
         continuait d'afficher la disponibilite de la variante precedente. */
      document.dispatchEvent(new CustomEvent('lf:variant:change', {
        detail: { indisponible: true, sectionId: sectionId }
      }));
      /* Le bouton etait desactive mais disait toujours « Ajouter au
         panier » : seul un message detache signalait l'indisponibilite. Le
         bouton le dit lui-meme. */
      poserBouton('indisponible');
      var accel = root.querySelector('.shopify-payment-button');
      if (accel) accel.hidden = true;
      var zone = root.querySelector('[data-lf-variant-status]');
      if (zone) {
        var mots = window.lfStrings || {};
        zone.textContent = mots.unavailable || 'This combination is not available';
      }
    }

    /* ---- Produits a plus de 250 variantes ----
       Shopify ne livre que 250 variantes dans `product.variants` : au-dela,
       une combinaison bien reelle manquait a la liste et le bouton annoncait
       « Unavailable ». On demande alors au serveur la variante des valeurs
       choisies (parametre `option_values`) ; il la rend, ou rien si la
       combinaison n'existe pas. Trouvee, elle rejoint la liste et le chemin
       ordinaire reprend. */
    function idsChoisis() {
      var ids = [];
      root.querySelectorAll('[data-lf-opt]:checked').forEach(function (i) {
        if (i.getAttribute('data-option-value-id')) ids.push(i.getAttribute('data-option-value-id'));
      });
      return ids.join(',');
    }

    function resoudreParServeur() {
      var cle = idsChoisis();
      if (!cle) { poserIndisponible(); return; }
      if (requeteVariante) requeteVariante.abort();
      requeteVariante = new AbortController();
      fetch(productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'option_values=' + cle + '&section_id=' + sectionId,
            { signal: requeteVariante.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (idsChoisis() !== cle) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var donnees = doc.querySelector('[data-lf-variant-data]');
          var id = donnees && donnees.getAttribute('data-lf-selected');
          if (!id) { poserIndisponible(); return; }
          variants.push({
            id: Number(id),
            available: donnees.getAttribute('data-lf-selected-available') === 'true',
            options: selectedOptions(),
            featured_media: null
          });
          onOptionChange();
        })
        .catch(function () {});
    }

    function onOptionChange() {
      var opts = selectedOptions();
      var variant = matchVariant(opts);
      if (!variant) {
        var total = dataEl ? parseInt(dataEl.getAttribute('data-lf-variants-total'), 10) || 0 : 0;
        if (total > variants.length) { resoudreParServeur(); return; }
        poserIndisponible();
        return;
      }

      var zone = root.querySelector('[data-lf-variant-status]');
      if (zone) zone.textContent = '';

      /* Le paiement accelere etait revele ici, sans condition — avant meme
         de savoir si la declinaison etait en stock. C'est `poserBouton` qui
         s'en charge desormais, avec l'etat sous les yeux. */
      if (idInput) idInput.value = variant.id;
      poserBouton(variant.available ? 'disponible' : 'epuise');
      var planAvant = planChoisi();

      /* La disponibilite en retrait ecoutait cet evenement, que personne
         n'emettait : elle restait sur la variante d'arrivee. */
      document.dispatchEvent(new CustomEvent('lf:variant:change', {
        detail: { variant: variant, sectionId: sectionId }
      }));

      // URL
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}

      // Média associé
      if (variant.featured_media) {
        var slide = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          /* `scrollIntoView` ne suffit pas sur une piste horizontale que le
             visiteur n'a pas encore sous les yeux : mesure faite sur le
             produit mis en avant, l'appel partait bien sur le bon media et
             la piste ne bougeait pas d'un pixel. On cale donc la piste
             nous-memes, et seulement si elle defile vraiment — sur la
             galerie en colonne de la fiche produit, la condition est fausse
             et rien ne change. */
          var piste = slide.parentElement;
          if (piste && piste.scrollWidth > piste.clientWidth + 1) {
            /* `offsetLeft` se compte depuis l'ancetre POSITIONNE, qui n'est
               pas forcement la piste : sur la galerie de la fiche produit,
               la soustraction donnait zero pour la dixieme vignette. Les
               rectangles, eux, sont toujours dans le meme repere. */
            var gauche = piste.scrollLeft
              + (slide.getBoundingClientRect().left - piste.getBoundingClientRect().left);
            if (piste.scrollTo) {
              piste.scrollTo({ left: gauche, behavior: 'smooth' });
              /* Le navigateur ignore un defilement doux demande sur un
                 conteneur qui n'est pas a l'ecran : mesure faite, `smooth`
                 laissait la piste a zero la ou `auto` la calait au pixel.
                 On laisse sa chance au glissement, et on rattrape sans
                 animation s'il n'a pas eu lieu — le visiteur qui ne voit
                 pas la piste ne perd rien, celui qui la voit garde le
                 mouvement. */
              setTimeout(function () {
                if (Math.abs(piste.scrollLeft - gauche) > 2) piste.scrollLeft = gauche;
              }, 420);
            } else {
              piste.scrollLeft = gauche;
            }
          }
        }
      }

      /* Chaque changement lancait sa requete sans annuler la precedente :
         une reponse lente pouvait revenir apres une plus recente et
         reafficher le prix d'une variante deja abandonnee. On annule, et
         on verifie au retour que la variante attendue est toujours celle
         qui est choisie. */
      if (requeteVariante) requeteVariante.abort();
      requeteVariante = new AbortController();
      var attendue = variant.id;

      fetch(urlSection(variant.id, planAvant), { signal: requeteVariante.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (idInput && String(idInput.value) !== String(attendue)) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          swap(doc, '[data-lf-price]');
          swap(doc, '[data-lf-atc]');
          /* Une variante peut n'avoir aucun rythme la ou la precedente en
             avait : `swap` ne remplace que ce qui existe des deux cotes,
             le bloc perime resterait affiche avec son champ cache. */
          if (doc.querySelector('[data-lf-selling-plans]')) {
            swap(doc, '[data-lf-selling-plans]');
          } else {
            var perime = root.querySelector('[data-lf-selling-plans]');
            if (perime) perime.remove();
          }
          reconduirePlan(planAvant);
        })
        .catch(function () {});
    }

    function swap(doc, selector) {
      var fresh = doc.querySelector(selector);
      var current = root.querySelector(selector);
      if (fresh && current) current.replaceWith(fresh);
    }

    /* ---- Valeurs d'option indisponibles ----
       Le bouton d'achat disait bien « Sold out » ou « Unavailable » une fois
       la combinaison formee, mais rien ne prevenait avant : le client devait
       essayer pour apprendre. La liste de controle de Shopify demande que les
       valeurs epuisees ou inexistantes soient marquees dans le selecteur
       lui-meme.

       Pour chaque valeur, on garde les choix faits sur les AUTRES options et
       on cherche une declinaison qui corresponde. Aucune : la valeur n'existe
       pas dans ce contexte. Une, mais epuisee : elle existe et manque.

       Les boutons restent activables a dessein. Les desactiver les sortirait
       du parcours clavier, et le client perdrait le message qui explique
       pourquoi — il verrait une case morte, sans raison. Barree, la valeur se
       lit, s'atteint, et le bouton d'achat dit la suite.

       Au-dela de 250 declinaisons, `product.variants` est tronque par Shopify
       et le marquage serait faux : on s'abstient plutot que de mentir. */
    var totalVariantes = parseInt(dataEl && dataEl.getAttribute('data-lf-variants-total'), 10) || variants.length;
    var marquageFiable = variants.length > 0 && totalVariantes <= variants.length;

    function marquerValeurs() {
      if (!marquageFiable) return;
      var groupes = {};
      root.querySelectorAll('[data-lf-opt]').forEach(function (input) {
        var pos = parseInt(input.name.replace('option', ''), 10);
        if (!pos) return;
        (groupes[pos] = groupes[pos] || []).push(input);
      });
      var choisis = [];
      root.querySelectorAll('[data-lf-opt]:checked').forEach(function (i) {
        choisis[parseInt(i.name.replace('option', ''), 10) - 1] = i.value;
      });

      Object.keys(groupes).forEach(function (pos) {
        groupes[pos].forEach(function (input) {
          var essai = choisis.slice();
          essai[pos - 1] = input.value;
          var existe = false;
          var dispo = false;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var colle = true;
            for (var j = 0; j < essai.length; j++) {
              if (essai[j] && v.options[j] !== essai[j]) { colle = false; break; }
            }
            if (!colle) continue;
            existe = true;
            if (v.available) { dispo = true; break; }
          }
          /* Deux balisages coexistent : la fiche produit enveloppe son
             bouton dans l'etiquette, le produit mis en avant les pose cote
             a cote et les relie par `for`. On accepte les deux, sinon le
             marquage ne s'applique qu'a l'un des deux. */
          var etiquette = input.closest('label');
          if (!etiquette && input.id) {
            etiquette = root.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          }
          if (!etiquette) return;
          etiquette.classList.toggle('is-indisponible', !dispo);

          /* Barrer ne dit rien a un lecteur d'ecran : l'etat est aussi
             ecrit, en texte masque, dans l'etiquette elle-meme. */
          var note = etiquette.querySelector('[data-lf-opt-etat]');
          if (dispo) {
            if (note) note.remove();
          } else {
            if (!note) {
              note = document.createElement('span');
              note.className = 'lf-visually-hidden';
              note.setAttribute('data-lf-opt-etat', '');
              etiquette.appendChild(note);
            }
            var libelles = window.lfStrings || {};
            note.textContent = ' (' + (existe ? libelles.soldOut : libelles.unavailableLabel) + ')';
          }
        });
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-lf-opt]')) {
        onOptionChange();
        filterMedia();
        marquerValeurs();
        var fs = e.target.closest('.lf-opt');
        var lbl = fs && fs.querySelector('[data-lf-opt-selected]');
        if (lbl) lbl.textContent = e.target.getAttribute('data-lf-opt-label') || e.target.value;
      }
    });

    filterMedia();
    marquerValeurs();

    /* ---- Ajout au panier ---- */
    if (form) {
      var ajoutEnCours = false;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        /* Le bouton n'est plus desactive pendant la requete : un bouton qui
           passe `disabled` perd le focus, qui tombait sur `body`. A la
           fermeture du tiroir, le clavier repartait du haut de la page. Un
           verrou empeche le double envoi, `aria-busy` annonce l'attente. */
        if (ajoutEnCours) return;
        ajoutEnCours = true;
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-loading');

        var body = new FormData(form);
        body.append('sections', 'header');

        if (btn) btn.setAttribute('aria-busy', 'true');

        /* `application/javascript`, et non `application/json` : sur la
           route du formulaire, le premier renvoie l'erreur detaillee de
           Shopify — « Variant can only be purchased with a selling plan. » —
           la ou le second se contente de `{"errors":"Cart Error"}`. Le
           Theme Store demande que ce message precis soit montre au client ;
           avec l'ancien en-tete, le theme n'avait jamais de quoi l'ecrire. */
        fetch(window.lfRoutes.cartAdd, {
          method: 'POST',
          headers: { 'Accept': 'application/javascript' },
          body: body
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            ajoutEnCours = false;
            if (btn) {
              btn.classList.remove('is-loading');
              btn.removeAttribute('aria-busy');
            }

            /* Shopify renvoie un statut et un message quand l'ajout echoue —
               stock insuffisant, variante invalide, regle de vente. Le code
               les ignorait : le bouton reprenait son etat normal et le client
               croyait avoir ajoute l'article. On affiche ce que le serveur
               dit, dans une zone que le lecteur d'ecran annonce. */
            if (data.status) {
              annonce(texteErreur(data));
              marquerChamps(data);
              return;
            }

            annonce('');
            marquerChamps(null);
            /* L'ajout peut reussir tout en etant plafonne par le stock : la
               reponse ne le dit pas. On compare la quantite demandee a ce que
               le panier contient reellement une fois mis a jour. */
            var plafond = '';
            var champQuantite = form.querySelector('[name="quantity"]');
            var demande = parseInt(champQuantite && champQuantite.value, 10) || 1;
            var avant = quantiteDansTiroir(data.key) || 0;
            if (data.sections && data.sections.header) {
              updateCart(data.sections.header);
              var apres = quantiteDansTiroir(data.key);
              if (apres !== null && apres < avant + demande) {
                var modele = (window.lfStrings || {}).cartQuantityError || '';
                var plafond = modele.replace('[quantity]', apres);
                annonce(plafond);
              }
            }
            // Le tiroir recouvre la zone d'erreur de la fiche : il reprend le
            // message sur la ligne concernee.
            document.dispatchEvent(new CustomEvent('lf:cart:open', {
              detail: { retour: btn, ligne: plafond ? { cle: data.key, texte: plafond } : null }
            }));
          })
          .catch(function () {
            ajoutEnCours = false;
            if (btn) {
              btn.classList.remove('is-loading');
              btn.removeAttribute('aria-busy');
            }
            var mots = window.lfStrings || {};
            annonce(mots.cartError || 'Something went wrong. Please try again.');
          });
      });
    }

    /* Shopify renvoie parfois l'erreur sous forme d'objet — pour une carte
       cadeau, { email: [...], send_on: [...] }. Ecrit tel quel, le message
       devenait « [object Object] ». On le met en phrases, champ par champ,
       en reprenant l'intitule visible de chaque champ. */
    var CHAMPS_DESTINATAIRE = {
      email: 'properties[Recipient email]',
      name: 'properties[Recipient name]',
      message: 'properties[Message]',
      send_on: 'properties[Send on]'
    };

    function champDe(cle) {
      var nom = CHAMPS_DESTINATAIRE[cle];
      return nom && form ? form.querySelector('[name="' + nom + '"]') : null;
    }

    function texteErreur(data) {
      var brut = data && (data.description || data.errors || data.message);
      var repli = (window.lfStrings || {}).cartError || '';
      if (!brut) return repli;
      if (typeof brut === 'string') return brut;
      if (Array.isArray(brut)) return brut.join(' ');
      return Object.keys(brut).map(function (cle) {
        var champ = champDe(cle);
        var etiquette = champ && champ.id ? document.querySelector('label[for="' + champ.id + '"]') : null;
        var texte = [].concat(brut[cle]).join(' ');
        return etiquette ? etiquette.textContent.trim() + ' : ' + texte : texte;
      }).join(' ') || repli;
    }

    function marquerChamps(data) {
      var brut = data && (data.description || data.errors);
      Object.keys(CHAMPS_DESTINATAIRE).forEach(function (cle) {
        var champ = champDe(cle);
        if (!champ) return;
        var fautif = brut && typeof brut === 'object' && !Array.isArray(brut) && brut[cle];
        if (fautif) champ.setAttribute('aria-invalid', 'true');
        else champ.removeAttribute('aria-invalid');
      });
    }

    /* Zone d'erreur du formulaire : elle porte `aria-live` cote balisage,
       donc le message est annonce sans deplacer le focus. */
    function annonce(texte) {
      var zone = root.querySelector('[data-lf-cart-error]');
      if (!zone) return;
      zone.textContent = texte || '';
    }

    function quantiteDansTiroir(cle) {
      var lignes = document.querySelectorAll('[data-lf-cart] [data-lf-cart-item]');
      for (var i = 0; i < lignes.length; i++) {
        if (lignes[i].dataset.key !== cle) continue;
        var champ = lignes[i].querySelector('[data-lf-qty-input]');
        return champ ? parseInt(champ.value, 10) : null;
      }
      return null;
    }

    function updateCart(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['[data-lf-cart-body]', '[data-lf-cart-foot]', '[data-lf-cart-head-count]'].forEach(function (sel) {
        var fresh = doc.querySelector(sel);
        var cur = document.querySelector(sel);
        if (fresh && cur) cur.replaceWith(fresh);
      });
      var freshCount = doc.querySelector('[data-lf-cart-count]');
      var curCount = document.querySelector('[data-lf-cart-count]');
      if (freshCount && curCount) curCount.replaceWith(freshCount);
    }
  }

  /* Flèches de la galerie photo (mobile) */
  function initGalleryNav(root) {
    var gallery = root.querySelector('.lf-product__gallery');
    var prev = root.querySelector('[data-lf-gallery-prev]');
    var next = root.querySelector('[data-lf-gallery-next]');
    if (!gallery || !prev || !next || root.dataset.gnavBound) return;
    root.dataset.gnavBound = '1';

    if (getComputedStyle(root).position === 'static') root.style.position = 'relative';

    function position() {
      // Placées discrètement vers le bas du carrousel photo
      var y = gallery.offsetTop + gallery.offsetHeight - 28;
      prev.style.top = y + 'px';
      next.style.top = y + 'px';
    }
    function refresh() {
      var scrollable = gallery.scrollWidth > gallery.clientWidth + 4;
      prev.classList.toggle('is-hidden', !scrollable || gallery.scrollLeft <= 4);
      next.classList.toggle('is-hidden', !scrollable || gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 4);
    }
    function step(dir) { gallery.scrollBy({ left: dir * gallery.clientWidth, behavior: 'smooth' }); }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    gallery.addEventListener('scroll', refresh, { passive: true });
    function update() { position(); refresh(); }
    update();
    requestAnimationFrame(update);
    [200, 600].forEach(function (d) { setTimeout(update, d); });
    gallery.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', update, { once: true }); });
    window.addEventListener('load', update);
    window.addEventListener('resize', function () { setTimeout(update, 150); }, { passive: true });
  }

  /* Bande de vignettes du mode carrousel.
     Delegation au niveau du document : la section produit est re-rendue
     a chaque changement de variante, et un ecouteur pose sur la bande
     resterait attache au noeud remplace. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.lf-product__thumb') : null;
    if (!t) return;
    var racine = t.closest('[data-lf-product]') || document;
    var gallery = racine.querySelector('.lf-product__gallery');
    if (!gallery) return;
    var slide = gallery.querySelector('.lf-product__slide[data-media-id="' + t.getAttribute('data-lf-thumb') + '"]');
    if (!slide || slide.style.display === 'none') return;
    var d = slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
    gallery.scrollTo({ left: gallery.scrollLeft + d, behavior: 'smooth' });
  });

  function initThumbs(root) {
    var bande = root.querySelector('[data-lf-thumbs]');
    var gallery = root.querySelector('.lf-product__gallery');
    if (!bande || !gallery || gallery.dataset.thumbsSync) return;
    gallery.dataset.thumbsSync = '1';

    function actif() {
      var slides = [].slice.call(gallery.querySelectorAll('.lf-product__slide'));
      var gr = gallery.getBoundingClientRect();
      var centre = gr.left + gr.width / 2;
      var best = null, dmin = Infinity;
      slides.forEach(function (s) {
        if (s.style.display === 'none') return;
        var r = s.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - centre);
        if (d < dmin) { dmin = d; best = s; }
      });
      var idActif = best ? best.getAttribute('data-media-id') : null;
      var courante = null;
      bande.querySelectorAll('.lf-product__thumb').forEach(function (v) {
        var on = v.getAttribute('data-lf-thumb') === idActif;
        v.classList.toggle('is-active', on);
        if (on) courante = v;
      });
      /* La bande est etroite : on la deroule pour garder la vignette
         active sous les yeux, sans jamais bouger la page. */
      if (courante) {
        var br = bande.getBoundingClientRect();
        var cr = courante.getBoundingClientRect();
        if (cr.left < br.left + 4) {
          bande.scrollLeft += cr.left - br.left - 8;
        } else if (cr.right > br.right - 4) {
          bande.scrollLeft += cr.right - br.right + 8;
        }
      }
    }
    /* Frise : largeur proportionnelle a la part visible, position
       proportionnelle a l'avancement. */
    var frise = root.querySelector('[data-lf-frise]');
    var barre = frise ? frise.querySelector('[data-lf-frise-bar]') : null;
    function majFrise() {
      if (!barre) return;
      var total = gallery.scrollWidth;
      var vue = gallery.clientWidth;
      if (total <= vue + 1) { frise.style.display = 'none'; return; }
      frise.style.display = '';
      var part = Math.max(0.08, vue / total);
      var course = frise.clientWidth * (1 - part);
      var avance = gallery.scrollLeft / (total - vue);
      barre.style.width = (part * 100) + '%';
      barre.style.transform = 'translateX(' + (avance * course) + 'px)';
    }

    function synchro() { actif(); majFrise(); }
    gallery.addEventListener('scroll', synchro, { passive: true });
    window.addEventListener('resize', synchro, { passive: true });
    synchro();
    [200, 700].forEach(function (d) { setTimeout(synchro, d); });
  }


  /* ---- Colonne d'informations : elle suit la page ----

     La colonne reste accrochee sous l'en-tete et porte son propre
     defilement, barre masquee. Ce qui depassait — description ouverte,
     accordeons — ne se voyait qu'en faisant defiler la colonne elle-meme :
     en descendant la page, on arrivait au bout de la galerie sur un texte
     coupe net contre la section suivante. La colonne avance maintenant avec
     la page et touche son bas en meme temps que la galerie.

     Le pas se calcule sur ce qui reste a parcourir, des deux cotes : si le
     visiteur a deja fait defiler la colonne a la main, elle rejoint la page
     en douceur au lieu de sauter a une position calculee. */
  function initColonneInfo(root) {
    var info = root.querySelector('.lf-product__info');
    var galerie = root.querySelector('.lf-product__gallery');
    if (!info || !galerie || root.dataset.colonneBound) return;
    root.dataset.colonneBound = '1';
    var large = window.matchMedia('(min-width: 990px)');
    var avant = null;
    var attente = false;

    function maj() {
      attente = false;
      if (!large.matches) { info.classList.remove('is-libre'); avant = null; return; }
      /* Galerie plus courte que les informations : rien a synchroniser,
         la colonne se deroule entiere.

         Sauf en carrousel : la galerie y tient volontairement dans la
         hauteur d'un seul visuel. La liberer laissait la colonne texte
         descendre seule et creusait 700 px de blanc a sa gauche. Elle
         garde donc son propre defilement, comme avant. */
      var carrousel = galerie.classList.contains('lf-product__gallery--carousel');
      info.classList.toggle('is-libre', !carrousel && galerie.offsetHeight < info.scrollHeight);
      var cs = getComputedStyle(info);
      var max = info.scrollHeight - info.clientHeight;
      if (cs.position !== 'sticky' || max <= 0) { avant = null; return; }
      var boite = info.parentElement.getBoundingClientRect();
      var course = boite.height - info.offsetHeight - (parseFloat(cs.marginBottom) || 0);
      if (course <= 0) { avant = null; return; }
      var fait = Math.min(course, Math.max(0, (parseFloat(cs.top) || 0) - boite.top));
      if (avant !== null && fait !== avant) {
        var pos = info.scrollTop;
        info.scrollTop = fait > avant
          ? pos + (max - pos) * (fait - avant) / Math.max(1, course - avant)
          : pos - pos * (avant - fait) / Math.max(1, avant);
      }
      avant = fait;
    }
    function demander() {
      if (attente) return;
      attente = true;
      requestAnimationFrame(maj);
    }
    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', function () { avant = null; demander(); }, { passive: true });
    // Accordeon ouvert, image chargee : les hauteurs changent sans defilement.
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(demander);
      ro.observe(galerie);
      if (info.firstElementChild) ro.observe(info.firstElementChild);
    }
    maj();
  }

  /* ---- Medias produit : un seul en lecture a la fois ----

     Une video MP4, un modele 3D et une video YouTube ou Vimeo pouvaient
     jouer ensemble : rien ne coordonnait les medias de la galerie. Quand le
     visiteur en lance un, tous les autres s'arretent.

     Seul un demarrage provoque par le visiteur compte. Les videos
     d'ambiance demarrent seules, muettes : si chacune arretait les autres
     en demarrant, elles se couperaient mutuellement au chargement. */
  var derniereAction = 0;
  ['pointerdown', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function () { derniereAction = Date.now(); }, true);
  });
  function voulu() { return Date.now() - derniereAction < 1500; }

  function pauserMedias(sauf) {
    document.querySelectorAll('[data-lf-product] video').forEach(function (v) {
      if (v !== sauf && !v.paused) v.pause();
    });
    document.querySelectorAll('[data-lf-product] .lf-product__external-video iframe').forEach(function (f) {
      if (f === sauf || !f.contentWindow) return;
      var src = f.getAttribute('src') || '';
      try {
        if (src.indexOf('youtube') !== -1) {
          f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (src.indexOf('vimeo') !== -1) {
          f.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      } catch (e) {}
    });
    document.querySelectorAll('[data-lf-product] model-viewer').forEach(function (m) {
      if (m === sauf) return;
      if (m.modelViewerUI && m.modelViewerUI.pause) m.modelViewerUI.pause();
      else if (typeof m.pause === 'function') m.pause();
    });
  }

  // Video du theme lancee par le visiteur.
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (v.tagName !== 'VIDEO' || !v.closest('[data-lf-product]') || !voulu()) return;
    pauserMedias(v);
  }, true);

  // Lecteur YouTube ou Vimeo : un clic dedans fait passer le focus a
  // l'iframe, et la page perd le sien.
  window.addEventListener('blur', function () {
    setTimeout(function () {
      var f = document.activeElement;
      if (f && f.tagName === 'IFRAME' && f.closest('[data-lf-product] .lf-product__external-video')) pauserMedias(f);
    }, 0);
  });

  // Modele 3D manipule.
  document.addEventListener('pointerdown', function (e) {
    var m = e.target.closest && e.target.closest('[data-lf-product] model-viewer, [data-lf-product] .lf-product__model');
    if (m) pauserMedias(m.tagName === 'MODEL-VIEWER' ? m : m.querySelector('model-viewer'));
  }, true);

  function boot() {
    document.querySelectorAll('[data-lf-product]').forEach(function (root) {
      init(root);
      initGalleryNav(root);
      initThumbs(root);

      initColonneInfo(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
